import { Controller } from 'react-hook-form';

import Field, { FieldProps } from 'ui/Field';
import NumberInput, { NumberInputProps } from 'ui/NumberInput';
import { useUpstreamFormPropagation } from 'utils/form';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import { isNumeric } from '../../utils/number';
import {
  getFieldMaxConstraint,
  getFieldMinConstraint,
} from '../../utils/validation';

type Props = NumberInputProps & {
  field: SankeyFormNumericField;
  label?: string;
  fieldFontSize?: FieldProps['fontSize'];
};

const FormNumberInput = ({ field, label, fieldFontSize, ...props }: Props) => {
  const { form } = useSankeyFormContext();

  // Propagate the number field value after 200ms to avoid too many re-renders while typing.
  useUpstreamFormPropagation(field, 200);

  return (
    <Controller
      name={field}
      control={form.control}
      render={({ field, fieldState }) => (
        <Field
          label={label}
          invalid={fieldState.invalid}
          fontSize={fieldFontSize}
          w="auto"
        >
          <NumberInput
            id={field.name}
            value={isNumeric(field.value) ? `${field.value}` : undefined}
            onValueChange={(e) =>
              field.onChange(isNumeric(e.value) ? Number(e.value) : undefined)
            }
            min={getFieldMinConstraint(field.name)}
            max={getFieldMaxConstraint(field.name)}
            {...props}
          />
        </Field>
      )}
    />
  );
};

export default FormNumberInput;
